import { createSignal } from 'solid-js'
import type { NormalizedFocusChallenges } from '~/resources/focus-challenges'

export type DevPreset =
  | 'off'
  | 'loading'
  | 'default'
  | 'in-progress'
  | 'claim-ready'
  | 'claimed'

const [preset, setPreset] = createSignal<DevPreset>('off')

function presetData(
  p: DevPreset,
  real: NormalizedFocusChallenges | null,
): NormalizedFocusChallenges | null {
  if (p === 'loading') return null
  if (!real) return null
  if (p === 'default') {
    return {
      ...real,
      monthly: real.monthly
        ? { ...real.monthly, progress: 0, status: 'active' }
        : null,
      monthlyClaimState: 'progress',
    }
  }
  if (p === 'in-progress') {
    return {
      ...real,
      monthly: real.monthly
        ? { ...real.monthly, progress: 12, status: 'active' }
        : null,
      monthlyClaimState: 'progress',
    }
  }
  if (p === 'claim-ready') {
    return {
      ...real,
      monthly: real.monthly
        ? { ...real.monthly, progress: 25, status: 'completed' }
        : null,
      monthlyClaimState: 'ready',
    }
  }
  if (p === 'claimed') {
    return {
      ...real,
      monthly: real.monthly
        ? { ...real.monthly, progress: 25, status: 'reward_delivered' }
        : null,
      monthlyClaimState: 'claimed',
    }
  }
  return real
}

export const devOverride = {
  preset,
  setPreset,
  apply(real: NormalizedFocusChallenges | null) {
    if (!import.meta.env.DEV) return real
    const p = preset()
    if (p === 'off') return real
    return presetData(p, real)
  },
}
